import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from 'api/Api';

export interface DesignProps {
  companyName?: string;
  description?: string;
  colorPrimary?: string;
  colorPrimaryLighter?: string;
  email?: string;
  logoUrl?: string;
  footerText?: string;
  domainUrl?: string;
  privacyUrl?: string;
  termsUrl?: string;
  donationUrl?: string;
  volunteerUrl?: string;
}

export const designApi = createApi({
  baseQuery: baseQueryWithReAuth,
  reducerPath: 'designApi',
  endpoints: (build) => ({
    getDesignConfig: build.query<DesignProps, { origin: string }>({
      query: (params) => ({
        url: '/design/config',
        params
      }),
      transformResponse: (response: { data: DesignProps }) => response.data
    })
  })
});

export const { useGetDesignConfigQuery } = designApi;
